import * as Firebase from '@pilopsoft/matchbox-cloudflare-functions';
import { api } from 'src/boot/axios';

const firebaseApiClient = Firebase.FirebaseApiFactory(
  undefined,
  '/firebase',
  api
);

export default {
  async loginUserPassword(
    request: Firebase.UserPassLoginRequestDTO
  ): Promise<Firebase.UserPassLoginResponseDTO> {
    return (await firebaseApiClient.loginUserPassword(request)).data;
  },

  async loginOAuth(
    request: Firebase.OauthLoginRequestDTO
  ): Promise<Firebase.OauthLoginResponseDTO> {
    return (await firebaseApiClient.loginOAuth(request)).data;
  },

  async refreshToken(
    request: Firebase.RefreshTokenRequestDTO
  ): Promise<Firebase.RefreshTokenResponseDTO> {
    return (await firebaseApiClient.refreshToken(request)).data;
  },

  async changePassword(
    request: Firebase.ChangePasswordRequestDTO
  ): Promise<Firebase.ChangePasswordResponseDTO> {
    return (await firebaseApiClient.changePassword(request)).data;
  },

  async verifyEmail(
    request: Firebase.VerifyEmailRequestDTO
  ): Promise<Firebase.VerifyEmailResponseDTO> {
    return (await firebaseApiClient.verifyEmail(request)).data;
  },

  async confirmEmail(
    request: Firebase.ConfirmEmailRequestDTO
  ): Promise<Firebase.ConfirmEmailResponseDTO> {
    return (await firebaseApiClient.confirmEmail(request)).data;
  },

  async updateProfile(
    request: Firebase.UpdateProfileRequestDTO
  ): Promise<Firebase.UpdateProfileResponseDTO> {
    return (await firebaseApiClient.updateProfile(request)).data;
  },
};
